import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import Dropdown, { DropdownOption } from './DropDown';

interface Props {
  fieldName: string;
  label: string;
  rules?: RegisterOptions;
  options: DropdownOption[];
  disabled?: boolean;
  multiple?: boolean;
  disableClearable?: boolean;
}

const ControlledDropdown = ({
  options,
  fieldName,
  label,
  rules,
  disabled,
  multiple,
  disableClearable,
}: Props) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={fieldName}
      control={control}
      rules={rules}
      defaultValue={multiple ? [] : null}
      render={({
        field: { onChange, value },
        fieldState: { error, isDirty },
      }) => (
        <Dropdown
          disabled={disabled}
          options={options ?? []}
          label={label}
          onChange={onChange}
          value={value}
          showError={isDirty && !!error}
          errorText={error?.message}
          multiple={multiple}
          disableClearable={disableClearable}
        />
      )}
    />
  );
};
export default ControlledDropdown;
